import { decode } from "html-entities";
import { assetDomain } from "../../../../config/config";
import {
  AiSummaryContainer,
  AiSummaryText,
  AiSummaryTextContainer,
  AiSummaryTitle,
  AiSummaryTitleContainer,
  AiSummaryTitleText,
  AshleyImage,
  BetaText,
  SparklesIconStyled,
  SpeechTail,
} from "./styles";

function SingleJobAiSummary(props) {
  const { job } = props || {};

  // To convert the hexadecimal characters and HTML entities from backend to string format
  function convertHexAndEntitiesToString(gptSummary) {
    let regexHex = /&#x([0-9a-fA-F]+);/g;

    let result = gptSummary?.replace(regexHex, function (match, hexValue) {
      let char = String.fromCharCode(parseInt(hexValue, 16));
      return char;
    });

    return decode(result);
  }

  return (
    <AiSummaryContainer>
      <AiSummaryTitleContainer>
        <AshleyImage
          draggable={false}
          src={assetDomain + "/images/hiredly/ashley-image.svg"}
          alt="ashley-avatar-image"
        />
        <AiSummaryTitleContainer>
          <AiSummaryTitle>
            <SparklesIconStyled />
            <AiSummaryTitleText variant="body1">
              AI-generated summary
            </AiSummaryTitleText>
          </AiSummaryTitle>
          <BetaText variant="subtitle1">beta</BetaText>
        </AiSummaryTitleContainer>
      </AiSummaryTitleContainer>

      <AiSummaryTextContainer>
        <AiSummaryText variant="body1" aria-label="chatgpt-job-summary">
          {job?.gptSummary
            ? convertHexAndEntitiesToString(job?.gptSummary)
            : "Oops, looks like Ashley forgot to summarize this job! We apologize for the inconvenience. Please read the complete Job Description for full details and additional information."}
        </AiSummaryText>
        <SpeechTail />
      </AiSummaryTextContainer>
    </AiSummaryContainer>
  );
}

export default SingleJobAiSummary;
